module.exports = __webpack_public_path__ + "img/head.a9e47cc7.png";